// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"_3eOEjrJv","mobileDropdown":"_234oeRfM","yahoo1":"_3FhMEcwb","credible":"BFAa2j4f"};